export const parseFinanceValues = (formData = {}) => {
  const parseNumber = (value) => {
    const parsed = parseFloat(value)
    return Number.isFinite(parsed) ? parsed : 0
  }

  return {
    vehicleCost: parseNumber(formData.VehicleCost),
    downPayment: parseNumber(formData.DownPayment),
    tenureMonths: parseInt(formData.EMITenure, 10) || 0,
    processingFees: parseNumber(formData.ProcessingFees),
    interestRate: parseNumber(formData.InterestRate)
  }
}

export const validateFinanceValues = (parsedValues = {}) => {
  const { vehicleCost, tenureMonths, interestRate } = parsedValues

  if (!vehicleCost) throw new Error('Enter vehicle cost to calculate loan summary.')
  if (tenureMonths <= 0) throw new Error('Enter EMI tenure (in months).')
  if (interestRate <= 0) throw new Error('Enter annual interest rate.')
}

export const calculateReducingRateSummary = (parsedValues = {}) => {
  const { vehicleCost, downPayment, tenureMonths, processingFees, interestRate } = parsedValues

  const principal = Math.max(vehicleCost - downPayment, 0) + processingFees
  const monthlyRate = interestRate / 12 / 100
  const factor = Math.pow(1 + monthlyRate, tenureMonths)
  const emi = monthlyRate === 0 || !Number.isFinite(factor)
    ? principal / tenureMonths
    : (principal * monthlyRate * factor) / (factor - 1)

  return {
    vehicleCost,
    downPayment,
    processingFees,
    interestRate,
    tenureMonths,
    loanAmount: principal,
    monthlyEmi: Number((emi || 0).toFixed(2)),
    totalPayable: Number(((emi || 0) * tenureMonths).toFixed(2))
  }
}
